import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@cosmos/angular/utils';
import { Sku } from '@cosmos/shared';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SkuService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) { }

  find(query=''): Observable<HttpResponse<Sku[]>> {
    return this.http
      .get<Sku[]>(`${environment.API_URL}/skus${query}`, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  findById(id: string, query = ''): Observable<HttpResponse<Sku>> {
    return this.http
      .get<Sku>(`${environment.API_URL}/skus/${id}${query}`, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  create(body: Sku | Partial<Sku>) {
    return this.http
      .post(`${environment.API_URL}/skus`, body, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  update(body: any) {
    return this.http
      .patch(`${environment.API_URL}/skus/${body[0]}`, body[1], {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  delete(id: string) {
    return this.http
      .delete(`${environment.API_URL}/skus/${id}`, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

}
